cb.define(['common/common_VM.Extend.js'], function(common) {
	var ST_st_storecheckreviewlist_filterVM_Extend = {
		doAction: function(name, viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function(viewmodel) {
			var parentViewModel;
			viewmodel.on('afterInit', function () {
				if(viewmodel.get('uncheckBasis')){
					viewmodel.get('uncheckBasis').getFromModel().setValue(0);
					viewmodel.get('uncheckBasis').getFromModel().setState('allowClear', false);
				}
			});
			viewmodel.on("beforeSearch", function(condition) {
				//两次，第一次是获取到盘点复核列表的viewmodel，继续获取父亲，才获取到盘点计划的viewmodel
				parentViewModel = viewmodel.getCache('parentViewModel').getCache('parentViewModel');
				if(!condition.simpleVOs){
					condition.simpleVOs=[];
				} 
				condition.simpleVOs.push({
					field: 'id',
					op: 'eq',
					value1: parentViewModel.get('id').getValue()
				});
        		//默认按照存量看漏盘
        		condition.simpleVOs.push({
        			field: 'resultdetails.stockbasis',
        			op: 'eq',
        			value1: '1'
        		});
        		condition['isExtend']=true;
        	});
		}

	}
	try {
		module.exports = ST_st_storecheckreviewlist_filterVM_Extend;
	} catch(error) {

	}
	return ST_st_storecheckreviewlist_filterVM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storecheckreviewlist2_filterVM.Extend.js